export function formatLinkedTextToMetadata (chains) {
  return chains.map(chain => chain.map(({ id, pageId }) => ({ element_id: id, page_id: Number(pageId) })));
}
